import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, "Loading Google Section...", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, "Loading Facebook Section...", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, "Loading sections...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroMTAgency = _resolveComponent("HeroMTAgency")!
  const _component_GoogleSection = _resolveComponent("GoogleSection")!
  const _component_FacebookSection = _resolveComponent("FacebookSection")!
  const _component_ServicesContactForm = _resolveComponent("ServicesContactForm")!
  const _component_ServicesFooter = _resolveComponent("ServicesFooter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_HeroMTAgency, { onPlatformSelected: _ctx.handlePlatformChange }, null, 8, ["onPlatformSelected"]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_ctx.selected === 'google')
            ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_GoogleSection)
                ]),
                fallback: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.selected === 'fb')
            ? (_openBlock(), _createBlock(_Suspense, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_FacebookSection)
                ]),
                fallback: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      fallback: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })),
    _createVNode(_component_ServicesContactForm, { platform: _ctx.selected }, null, 8, ["platform"]),
    _createVNode(_component_ServicesFooter)
  ]))
}